import { Outlet, useNavigate, useRoute } from '@buzola/router'
import { useEffect, useMemo } from 'react'
import { Shell } from '~/app/components/layout'
import { OrgNavigation } from '~/app/components/navigation'
import { setLastOrgId } from '~/lib/routing/org-context'

export default function OrgLayout() {
	const { matches } = useRoute()
	const navigate = useNavigate()

	const organizationId = useMemo(() => {
		for (const match of matches) {
			if (match.params.organizationId) return match.params.organizationId
		}
		return undefined
	}, [matches])

	useEffect(() => {
		if (organizationId) setLastOrgId(organizationId)
	}, [organizationId])

	useEffect(() => {
		if (!organizationId) navigate('app', { replace: true })
	}, [organizationId, navigate])

	return (
		<Shell navigation={<OrgNavigation />}>
			<Outlet />
		</Shell>
	)
}
